module.exports = __webpack_public_path__ + "static/media/s_v10_4.ed7359ca.mp3";